
import { observable, toJS, makeObservable } from 'mobx';

// !dummy Data
import axios from 'axios';
import * as APITypes from "../../../constants/API"
import QmsStorageKeys from 'constants/QmsStorageKeys';
import StorageKeys from 'constants/StorageKeys';
import QmsDetailsPageStore from '../qms-details-page/QmsDetailsPageStore'
import { lowerCase } from 'lodash';
import encryptData from 'utils/encrypData';
import getCookie from 'utils/journeyIdCookie/getJourneyId';

class BonusCampaignStore {
    qmsListData = {}
    pasaListData = {}
    campaignListCount = 0
    totalPageCount = 0
    selectedScreen = 'Quotes & Applications [10]'
    showDocumentList = false
    documentList = []
    productCardUniqueId = ""

    constructor() {
        makeObservable(this, {
            qmsListData: observable,
            totalPageCount: observable,
            selectedScreen: observable,
            pasaListData: observable,
            showDocumentList: observable,
            documentList: observable,
            productCardUniqueId: observable,
            campaignListCount: observable
        });
    }

    setshowDocumentList(value) {
        this.showDocumentList = value
    }

    setDocumentList(value) {
        this.documentList = value
    }

    async savePragatiInBoundData(agentId, page, journeyId) {
        let channelName = ['OA', 'CBM', 'DIS', 'IM']
        let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];

        localStorage.setItem(QmsStorageKeys.AGENT_ID, agentId)

        const response = await axios(APITypes.PRAGATI_QMS_INBOUND_DATA + `?agent_id=${agentId}`);
        console.log("QMS ::::", response.data);

        localStorage.setItem(QmsStorageKeys.AGENT_NAME, response.data.agent_name)
        localStorage.setItem(QmsStorageKeys.PRAGATI_HOME_URL, response.data.home_url)
        localStorage.setItem(QmsStorageKeys.PRAGATI_POST_CALL_END_POINT_URL, response.data.post_call_end_point)
        localStorage.setItem(QmsStorageKeys.LOGIN_CODE, response.data.login_code)
        localStorage.setItem(QmsStorageKeys.VENDOR, response.data.vendor_code)
        localStorage.setItem(QmsStorageKeys.SOURCE_FROM, "QMS")
        localStorage.setItem(QmsStorageKeys.LOGIN_AGENT_CODE, response.data.login_agent_code)
        localStorage.setItem(QmsStorageKeys.START_APPLICATION_END_POINT_URL, response.data.start_app_end_point)

        let hlData = await this.hlAgentApiCall(response?.data?.login_agent_code)

        await localStorage.setItem(StorageKeys.ULIP_TRAINING, hlData?.agent_details?.ulip_training)
        await localStorage.setItem(QmsStorageKeys.AGENT_NAME, hlData?.agent_details?.agent_name);
        await localStorage.setItem(QmsStorageKeys.ORIGANAL_DESIGNATION_CODE, hlData?.agent_details?.designation_code);

        let designation_code = this.formatDesignationCode(hlData?.agent_details?.designation_code)

        await localStorage.setItem(QmsStorageKeys.DESIGNATION_CODE, designation_code);
        await localStorage.setItem(QmsStorageKeys.CHANNEL_CODE, hlData?.channel_code);
        await localStorage.setItem(QmsStorageKeys.AGENT_CODE, hlData?.agent_code);

        let agent_code = hlData?.agent_code
        if (!channelName.includes(channel_code)) {
            await this.fetchQmsListData(agentId, page, journeyId, agent_code)
        }
    }

    async hlAgentApiCall(login_agent_code) {
        if (login_agent_code) {
            const encryptSPCode = await encryptData(login_agent_code)
            let hlAgentDetails = await axios.post(APITypes.HL_API, {
                agent_token: encryptSPCode,
            });
            return hlAgentDetails.data.response_data?.agentHierarchyResponse
        }

    }

    async fetchQmsListData(agentId, page, journeyId, agent_code) {
        const response = await axios.get(`${APITypes.GET_QMS_LIST}?agent_id=${agentId}&page_number=${page}&journey_id=${journeyId}&logged_in_agent=${agent_code}`)
        this.qmsListData = response.data
        this.totalPageCount = response.data.number_of_pages
        // this.qmsListData = qmsDashboardData
    }

    async fetchPasaListData(dm, pfa, dmID, pfaID, showPfa, agentID, page, searchKey, searchValue, product, channelCode) {
        let data = {}
        if (channelCode === "OA") {
            data = { dm: dm, pfa: pfa, bm: [], rm: [], show_pfa: showPfa, dm_id: dmID, pfa_id: pfaID, bm_id: null, rm_id: null, logged_in_agent: agentID, page_number: page, search_key: searchKey, search_value: searchValue, product: product, channel_code: channelCode, campaign:"upselling"}
        } else if (channelCode === "CBM" || channelCode === "IM") {
            data = { dm: [], pfa: pfa, bm: dm, rm: [], show_pfa: showPfa, dm_id: null, pfa_id: pfaID, bm_id: dmID, rm_id: null, logged_in_agent: agentID, page_number: page, search_key: searchKey, search_value: searchValue, product: product, channel_code: channelCode, campaign:"upselling"}
        } else if (channelCode === "DIS") {
            data = { dm: [], pfa: [], rm: pfa, bm: dm, show_pfa: showPfa, dm_id: null, pfa_id: null, bm_id: dmID, rm_id: pfaID, logged_in_agent: agentID, page_number: page, search_key: searchKey, search_value: searchValue, product: product, channel_code: channelCode, campaign:"upselling"}
        }
        let response = await axios.post(
            APITypes.GET_PASA_CARD_LIST,
            data
        )
        // let response = await axios.post(
        //     APITypes.GET_PASA_CARD_LIST
        // )
        if (response.status === "success") {
            // this.qmsListData = response.data
            this.pasaListData = response.data
            this.totalPageCount = response.data.number_of_pages
            this.campaignListCount = response.data?.all_journey_list ? response.data?.all_journey_list.length : 0
        }
    }

    async fetchAgentHeirarchy(role, agentId, channelCode, origanal_role) {
        let obj
        let data = []
        if (role && agentId) {
            obj = `designation_name=${origanal_role}&agent_code=${agentId}&channel_code=${channelCode}`
        }
        role = lowerCase(role)

        if (!role.includes('pfa') && !role.includes('rm')) {
            const response = await axios.get(`${APITypes.FETCH_AGENTS_HIERARCHY}?${obj}`)
            if (response.status === "success") {
                for (const [key, value] of Object.entries(response.data)) {
                    data.push({
                        key: key,
                        value: value,
                        OriginalValue: value
                    })
                }
            }
            if (data) {
                for (const item of data) {
                    if (item.value != 0) {
                        item.value.splice(0, 0, {
                            agentCode: "All",
                            agentName: "All",
                            designationCode: "All"
                        })
                    }
                }
            }
        } else if (channelCode === "CBM" || channelCode === "IM") {
            data.push({
                key: "rh", value: []
            }, { key: "ch", value: [] }, { key: "tm", value: [] }, { key: "bm", value: [] }, { key: "pfa", value: [] });
        }
        else if (channelCode === "OA") {
            data.push({
                key: "rh", value: []
            }, { key: "ch", value: [] }, { key: "bh", value: [] }, { key: "dm", value: [] }, { key: "pfa", value: [] });
        }
        else if (channelCode === "DIS") {
            data.push({
                key: "rh", value: []
            }, { key: "ch", value: [] }, { key: "bh", value: [] }, { key: "bm", value: [] }, { key: "rm", value: [] });
        }

        return data

    }

    async fetchJourneySummary(rh, ch, bh, dm, pfa, rhID, chID, bhID, dmID, pfaID, channelCode) {
        let data = {}
        if (channelCode === "OA") {
            data = {
                rh: rh, ch: ch, bh: bh, dm: dm, pfa: pfa, rm: [], bm: [], tm: [], rh_id: rhID, ch_id: chID, bh_id: bhID, dm_id: dmID, pfa_id: pfaID, rm_id: null, tm_id: null, bm_id: null, channel_code: channelCode, campaign:"upselling"
            }
        } else if (channelCode === "CBM" || channelCode === "IM") {
            data = {
                rh: rh, ch: ch, bm: dm, tm: bh, pfa: pfa, rm: [], bh: [], dm: [], rh_id: rhID, ch_id: chID, bh_id: null, dm_id: null, pfa_id: pfaID, tm_id: bhID, bm_id: dmID, rm_id: null, channel_code: channelCode, campaign:"upselling"
            }
        } else if (channelCode === "DIS") {
            data = {
                rh: rh, ch: ch, bh: bh, bm: dm, rm: pfa, tm: [], pfa: [], dm: [], rh_id: rhID, ch_id: chID, bh_id: bhID, bm_id: dmID, rm_id: pfaID, dm_id: null, pfa_id: null, tm_id: null, channel_code: channelCode, campaign:"upselling"
            }
        }

        let response = await axios.post(
            APITypes.FETCH_CAMPAIGN_JOURNEY_SUMMARY,
            data
        )
        // let response = {
        //     "data": {
        //         "number_of_pfa": 1,
        //         "number_of_leads": 17,
        //         "number_of_quotes_shared": 1,
        //         "number_of_logins": 2
        //     }
        // }
        return response
    }

    async fetchPdfUrl(solutionData, proposerData) {

        const response = await axios.post(APITypes.FETCH_SOLUTION_PDF_FROM_DMS,
            {
                "dms_id": solutionData.solution_dms_id
            });

        if (response.status === "success") {
            let proposerName = proposerData.salutation + " " + proposerData.first_name + " " + proposerData.middle_name + " " + proposerData.last_name
            QmsDetailsPageStore.downloadQuotePdf(response.data.pdf_url, proposerName, solutionData.solution_dms_id)
        }
    }


    getFamilyMemberName(proposerDetails, showMemberType, journeyData, showJourneyId) {
        if (Object.keys(proposerDetails).length > 0) {

            try {
                const { salutation, first_name, last_name, middle_name, proposer_member_type } = proposerDetails;

                let proposerName = "";
                if (first_name !== null) {

                    if (first_name !== null) {
                        proposerName += first_name + " ";
                    }

                    if (middle_name !== null) {
                        proposerName += middle_name + " ";
                    }

                    if (last_name !== null) {
                        proposerName += last_name;
                    }

                    proposerName.trim();
                }
                if (proposerName === "" && showJourneyId) {
                    return `Journey Id - ${journeyData.journey_id}`;
                } else if (proposerName !== "") {
                    return `${salutation} ${proposerName}`;

                } else {
                    return ""
                }
            } catch (err) {
                return "";
            }
        } else {
            return `Journey Id - ${journeyData.journey_id}`;
        }
    }

    updateAgentHeirarchy(data, agentData, name) {

        var newagentData = []
        if (data === 'All') {
            newagentData = agentData.map((item) => {
                if (item.key === name) {
                    return { ...item, value: item.OriginalValue };
                } else {
                    return item;
                }
            });


        } else {
            newagentData = agentData.map((item) => {
                if (item.key === name) {
                    let value = item.OriginalValue.filter((value) => value.reportingName === data)
                    value.splice(0, 0, {
                        agentCode: "All",
                        agentName: "All",
                        designationCode: "All"
                    })
                    return { ...item, value: value };
                } else {
                    return item;
                }
            });
        }
        return newagentData;
    }

    agentName = (name) => {
        if (name.includes('rh')) {
            return 'Region Heads'
        } else if (name.includes('bh')) {
            return 'Branch Heads'
        } else if (name.includes('dm')) {
            return 'DM'
        } else if (name.includes('pfa')) {
            return 'PFA'
        } else if (name.includes('date')) {
            return 'DATE'
        } else if (name.includes('solution coverage')) {
            return 'Solution Coverage'
        } else if (name.includes('tm')) {
            return 'TM'
        } else if (name.includes('bm')) {
            return 'BM'
        } else if (name.includes('ch')) {
            return 'CH'
        } else if (name.includes('rm')) {
            return 'RM'
        }

    }

    setRole = (name, channelCode) => {
        if (name === "Branch Heads" && channelCode === "OA") {
            return "dm"
        } else if (name === "Branch Heads" && channelCode === "DIS") {
            return "bm"
        } else if (name === "TM" && (channelCode === "CBM" || channelCode === "IM")) {
            return "bm"
        }

        if (name === "BM" && channelCode === "DIS") {
            return "rm"
        } else {
            return "pfa"
        }
    }

    formatDesignationCode = (Code) => {
        let designationCode = Code?.replace(/\s+/g, '');
        let rh_designation = ['C-RH', 'RH', 'D-ZSM', 'D-RH', 'IMC-RH']
        let ch_designation = ['CH', 'A-CH', 'D-CBH', 'D-RSM', 'IMC-CH']
        let tm_designation = ['C-MCBM', 'C-STM', 'C-AM', 'C-TM', 'C-ETM', 'C-CTM', 'IMC-TM']
        let pfa_designation = ['C-PFA', 'C-POSP', 'PFA', 'A-PFA', 'A-POSP', 'IMC-PFA','A-WP','A-SWP','A-CWP','A-EWP']
        let bh_designation = ['BH', 'A-BM', 'D-ASH']
        let bm_designation = ['C-CBM2', 'C-CBM1', 'C-CBM', 'C-SBM2', 'C-SBM1', 'C-SBM', 'C-BM2', 'C-BM1', 'C-BM', 'C-SBM2', 'C-SBM1', 'C-CBM2', 'C-CBM1', 'C-BM2', 'C-BM1', 'D-BM', 'D-SBM', 'D-CBM', 'IMC-LIM']
        let dm_designation = ['DM', 'DM-2', 'SDM-2', 'SDM-1']
        let zh_designation = ['C-ZH', 'A-ZH']
        let nh_designation = ['C-NH', 'NH']
        let rm_designation = ['D-BDM', 'D-CRM', 'D-DCRM', 'D-DFE', 'D-DRM', 'D-FE', 'D-RM', 'D-SBDM', 'D-SCRM', 'D-SFE', 'D-SRM']
        if (rh_designation.includes(designationCode)) {
            return "RH"
        } else if (ch_designation.includes(designationCode)) {
            return "CH"
        } else if (tm_designation.includes(designationCode)) {
            return "TM"
        } else if (pfa_designation.includes(designationCode)) {
            return "PFA"
        } else if (bh_designation.includes(designationCode)) {
            return "BH"
        } else if (bm_designation.includes(designationCode)) {
            return "BM"
        } else if (dm_designation.includes(designationCode)) {
            return "DM"
        } else if (zh_designation.includes(designationCode)) {
            return "ZH"
        } else if (nh_designation.includes(designationCode)) {
            return "NH"
        } else if (rm_designation.includes(designationCode)) {
            return "RM"
        }
    }

    setSelectedScreenQMS = (value) => {
        this.selectedScreen = value
    }

    updateProposerCard = (is_pasa, la_id, proposer_id) => {
        let data = toJS(this.pasaListData)

        data.forEach((item, index) => {
            item.journey_list.map((proposerdata, index) => {
                if (proposerdata?.id === proposer_id && item?.la_id === la_id) {
                    proposerdata.pasa_Available = is_pasa
                }
            })
        })
        this.pasaListData = data
    }

    fetchDocumentList = async (solutionIds) => {
        const response = await axios.get(
            APITypes.GET_DOCUMENT_LIST + `?ids=${solutionIds}`
        );
        return response;
    };

    processDocumnetList = async (data) => {
        const solutionIds = JSON.parse(localStorage.getItem("solutionList"));
        let response = {}
        const saveDocumentData = await axios.post(
            APITypes.SAVE_DOCUMENT_LIST,
            data
        );
        const requestObj = {
            "solution_list": [solutionIds],
            "default_email": [],
            "optional_email": "",
            "share_optional_email": false
        }
        if (saveDocumentData.status == "success") {
            response = await axios.post(APITypes.SEND_PDF, requestObj)
        }
        return response
    }

    sendSolutionList = async () => {

        return response
    }

    async saveCardStatus(journeyId) {
        let data = {
            journey_id: journeyId,
            lead_action: true
        }
        await axios.post(APITypes.SAVE_CAMPAIGN_LEAD_ACTION, data)

    }
}

export default new BonusCampaignStore();
